const $ = jQuery.noConflict();
function isEmpty( el ){
  return !$.trim(el.html())
}

function showProductPopup() {

    const productPopup = $('.productPopup');
    const text = productPopup.find('.woocommerce-notices-wrapper');
    if (productPopup.length > 0 && !isEmpty(text)) {
        productPopup.addClass('active');
    }
}
export default showProductPopup;
